// extracted by mini-css-extract-plugin
module.exports = {"Education":"EducationFR_Education__1QfMS"};